<div class="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl sm:p-6">
  <div class="flex items-start justify-between gap-4">
    <div class="min-w-0">
      <h2 class="text-lg font-semibold text-slate-950">Invite member</h2>
      <p class="mt-1 text-sm text-slate-500">
        Send an invitation to join this workspace.
      </p>
    </div>
    <button
      type="button"
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-lg text-slate-500 transition hover:bg-slate-100"
      aria-label="Close"
      (click)="close()">
      ×
    </button>
  </div>

  <div class="mt-5 flex flex-col gap-4">
    <lib-signal-text-field
      label="Email"
      placeholder="jane@acme.com"
      inputType="email"
      autocomplete="email"
      [value]="email()"
      [debounceValueChange]="false"
      (valueChange)="email.set($event)" />

    <lib-signal-dropdown
      label="Role"
      [items]="roleOptions"
      valuePath="value"
      displayPath="label"
      [value]="selectedRole()"
      [debounceValueChange]="false"
      (valueChange)="onRoleChange($event)" />

    <div class="mt-2 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
      <lib-signal-button
        appearance="outline"
        [disabled]="inviteState.loading()"
        (clicked)="close()">
        Cancel
      </lib-signal-button>
      <lib-signal-button
        [loading]="inviteState.loading()"
        [disabled]="inviteState.loading()"
        (clicked)="onSendInvite()">
        Send invite
      </lib-signal-button>
    </div>
  </div>
</div>
